export const signupsSelectors = {
  isFetching: state => state.signups.isFetching,
  isPending: state => state.signups.isPending,
};
